import { jsxs as o, jsx as l, Fragment as U } from "react/jsx-runtime";
import B from "react";
import { useI18n as O } from "next-localization";
import { c as e } from "./clsx.OuTLNxxd.js";
import { u as j } from "./use-find-er-wait-times.uMK5TOOU.js";
import { locationHasHours as P } from "../utils/locations/index.js";
import { NeuAccordion as d } from "@hcahealthcaredpx/neutron-react";
import { NextImage as A } from "@sitecore-jss/sitecore-jss-nextjs";
import { A as W } from "./address.DETex_qU.js";
import { ConditionalWrap as _ } from "../components/conditional-wrap/index.js";
import { D } from "./divider.C0gR8ZZB.js";
import { C as E, b as i, W as H, V as M } from "./get-location-specialty.BcQ-y3WW.js";
import { L as f, D as S } from "./location-result-title-link.ZW3Y-crM.js";
import { a as V } from "./place-in-line.C96L-sbv.js";
import { O as $ } from "./OfficeHours.BJ53cYvq.js";
import { P as G } from "./PhoneNumber.DBkB7rEx.js";
import { S as J } from "./StatusBlock.CaOts-jr.js";
import { T as R } from "./tagged-wrapper.BVuatn8C.js";
import { U as X } from "./unified-link.DNdCokeG.js";
import { u as Z } from "./use-place-in-line.BoUjg3Ed.js";
const q = "locations?facilityId=", z = "location-details", g = "120", ya = ({
  item: a,
  onItemClick: n,
  locationsUrl: N,
  isOpen: y = !0,
  addTaggedWrapper: b = !0
}) => {
  const { t: s } = O(), { data: h, isValidating: C, isLoading: I } = Z({ revalidateOnFocus: !0 }), v = j(a == null ? void 0 : a.erFeed), L = !!(a != null && a.facilityId), r = "neu-text-body fw-bold mb-1", u = "col-sm-12 pt-lg-0 pt-4", t = N ?? (a == null ? void 0 : a.marketedWebsite) ?? (a == null ? void 0 : a.url), x = /* @__PURE__ */ o("div", { className: a != null && a.locationImageUrl ? "" : "col-xs-12 col-lg-3", children: [
    /* @__PURE__ */ l(
      "p",
      {
        className: e(
          {
            "detail__title--last": a == null ? void 0 : a.locationImageUrl
          },
          "pt-4",
          r
        ),
        children: s("Locations.Card.MainFacility")
      }
    ),
    /* @__PURE__ */ l(
      X,
      {
        field: {
          value: {
            href: a == null ? void 0 : a.mainFacilityLocationUrl,
            text: (a == null ? void 0 : a.mainFacilityLocationName) ?? `${s("Locations.Card.GoTo")} ${s("Locations.Card.MainFacility")}`
          }
        }
      }
    )
  ] }), { SpecialtyButton: F, GetDirectionsButton: w, ViewOnMapButton: T, WebsiteButton: p } = E, k = B.useCallback(
    (c) => {
      n && (c.stopPropagation(), Object.defineProperty(c.currentTarget.dataset, "testId", {
        value: z
      }), n(c));
    },
    [n]
  );
  return /* @__PURE__ */ l(
    _,
    {
      condition: b,
      wrapper: (c) => /* @__PURE__ */ o(
        R,
        {
          onContainerClick: n,
          onClick: k,
          tag: s("Common.Location"),
          children: [
            c,
            /* @__PURE__ */ l(D, { className: "mt-0 mb-2" })
          ]
        }
      ),
      wrappedJSX: L ? /* @__PURE__ */ l(d, { className: "border border-neu-gray-10", children: /* @__PURE__ */ o(d.Item, { active: y, className: "content-overflow-visible", children: [
        /* @__PURE__ */ l(d.Header, { className: "ps-0 neu-bg-gray-0-hover", children: /* @__PURE__ */ l(U, { children: /* @__PURE__ */ o("div", { className: "d-flex row ps-4 py-2", children: [
          /* @__PURE__ */ l("div", { className: "col-12 align-items-lg-center align-items-start", children: /* @__PURE__ */ l(
            f,
            {
              facilityTitle: a != null && a.pageTitle ? a.pageTitle : a == null ? void 0 : a.marketedFacilityName,
              facilityUrl: t,
              distance: a == null ? void 0 : a.distance,
              className: "d-flex align-items-lg-center align-items-top",
              distanceClass: "col-3 d-none d-lg-flex justify-content-end",
              titleClass: e("mb-2", (a == null ? void 0 : a.distance) && "col-12 col-lg-8")
            }
          ) }),
          a != null && a.urgentCareFacilityId ? /* @__PURE__ */ l(
            V,
            {
              ucFacilityId: a == null ? void 0 : a.urgentCareFacilityId,
              waitTimes: h,
              isLoading: I || C
            }
          ) : null,
          /* @__PURE__ */ o("div", { className: "d-lg-flex col-lg-11 pe-0 align-items-lg-end", children: [
            /* @__PURE__ */ l(
              J,
              {
                result: a,
                erFeed: v,
                className: "col-lg-8",
                facilityTypeClass: "d-block d-lg-inline-block",
                erWaitClass: "d-block d-lg-inline-block"
              }
            ),
            /* @__PURE__ */ o("div", { className: "pt-2 pt-lg-0 pe-0 col-lg-4 col-12 d-flex justify-content-between justify-content-lg-end", children: [
              /* @__PURE__ */ l(i, { buttonOrder: [p], result: a }),
              /* @__PURE__ */ l(
                S,
                {
                  distance: a == null ? void 0 : a.distance,
                  className: "col-6 d-flex justify-content-end d-lg-none"
                }
              )
            ] })
          ] })
        ] }) }) }),
        /* @__PURE__ */ o(d.Content, { className: "neu-bg-gray-0", children: [
          /* @__PURE__ */ o("div", { className: "row", children: [
            /* @__PURE__ */ l(
              W,
              {
                className: a != null && a.locationImageUrl ? "col-lg-4 col-sm-12" : "col-lg-6 col-sm-12",
                title: s("Locations.Card.Address"),
                titleClassName: r,
                street1: a.street1,
                street2: a.street2,
                city: a.city,
                state: a.state,
                postalCode: a.postalCode
              }
            ),
            /* @__PURE__ */ l(
              G,
              {
                title: s("Locations.Card.PhoneNumber"),
                titleClassName: r,
                phoneNumber: a.marketedPrimaryPhoneNumber,
                className: a != null && a.locationImageUrl ? e("col-lg-4", u) : e("col-lg-6", u)
              }
            ),
            (a == null ? void 0 : a.locationImageUrl) && /* @__PURE__ */ l("div", { className: "d-none d-lg-flex col-4 justify-content-end", children: /* @__PURE__ */ l(
              A,
              {
                className: "object-fit-cover",
                field: {
                  src: a == null ? void 0 : a.locationImageUrl,
                  alt: a == null ? void 0 : a.marketedFacilityName,
                  stylelabsContentType: "Image",
                  width: g,
                  height: g
                }
              }
            ) }),
            (a == null ? void 0 : a.mainFacilityLocationUrl) && x
          ] }),
          /* @__PURE__ */ l("div", { className: "pt-4", children: /* @__PURE__ */ l(
            i,
            {
              buttonOrder: [F, w, T],
              result: a,
              cardButtonsClassName: "me-2 mb-2",
              viewOnMapUrl: `${q}${a.facilityId}`
            }
          ) }),
          P(a) && /* @__PURE__ */ l("div", { className: "pt-2", children: /* @__PURE__ */ l(
            $,
            {
              result: a,
              titleClassName: r,
              hoursButtonClassName: "pt-1",
              fontClassName: "neu-text-caption",
              dropdownClassNames: {
                menuJustifyClass: "justify-content-start"
              }
            }
          ) }),
          /* @__PURE__ */ o("div", { className: "pt-4 row", children: [
            /* @__PURE__ */ l("div", { className: "col-lg-6", children: /* @__PURE__ */ l(
              H,
              {
                className: "w-100",
                result: a,
                facilityName: (a == null ? void 0 : a.marketedFacilityName) ?? (a == null ? void 0 : a.facilityName) ?? (a == null ? void 0 : a.locationName)
              }
            ) }),
            /* @__PURE__ */ l("div", { className: "col-lg-6", children: /* @__PURE__ */ l(
              M,
              {
                className: "w-100 mt-lg-0 mt-2",
                result: a,
                facilityName: (a == null ? void 0 : a.marketedFacilityName) ?? (a == null ? void 0 : a.facilityName) ?? (a == null ? void 0 : a.locationName)
              }
            ) })
          ] })
        ] })
      ] }) }) : /* @__PURE__ */ l("div", { className: "d-flex ps-4 pe-5 py-4 border border-neu-gray-10", children: /* @__PURE__ */ o("div", { className: "d-flex flex-wrap justify-content-between col-11", children: [
        /* @__PURE__ */ l(
          f,
          {
            facilityTitle: a == null ? void 0 : a.pageTitle,
            facilityUrl: t,
            className: "col-12 col-lg-auto"
          }
        ),
        /* @__PURE__ */ l("div", { className: "d-flex align-self-center col-12 col-lg-auto mt-2 mt-lg-0", children: /* @__PURE__ */ l(
          i,
          {
            buttonOrder: [p],
            result: {
              ...a,
              locationUrl: t
            }
          }
        ) })
      ] }) })
    }
  );
};
export {
  ya as L
};
